<div class="modal-header">
    <h4 class="modal-title">{{ 'NOTIFICATION_DETAILS_PCH_ALERT_TITLE' | translate }}</h4>
    <span class="close" (click)="closeModal()">×</span>
</div>

<div class="modal-body">
    <p [innerHTML]="'NOTIFICATION_DETAILS_PCH_ALERT_BODY' | translate"></p>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onRequest()">Request</button>
</div>
